import { FC, useEffect, useRef } from "react";
import CalendarNav from "./weekView/CalendarNav";
import SideBarHours from "./weekView/SideBarHours";
import VerticalLines from "./weekView/VerticalLines";
import Appointments from "./weekView/Appointments";
import { appointmentsStatus, views } from "../../../types/calendar";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getAppointments } from "../../../network/calendar";
import {
  formatDateToYYYYMMDD,
  getWeekDays,
  weekEnd,
  weekStart,
} from "../../../utils/DateUtils";

interface CalendarBodyProps {
  clickOnDay: ({ date, startTime }: { date: Date; startTime: string }) => void;
  dateAndTime: {
    date: Date | null;
    startTime: string | null;
    finishTime: string | null;
  };
  setDateAndTime: React.Dispatch<
    React.SetStateAction<{
      date: Date | null;
      startTime: string | null;
      finishTime: string | null;
    }>
  >;
  searchFilter: string | null;
  statusFilter: appointmentsStatus | null;
}

const CalendarBody: FC<CalendarBodyProps> = ({
  clickOnDay,
  dateAndTime,
  setDateAndTime,
  searchFilter,
  statusFilter,
}) => {
  const navRef = useRef<HTMLDivElement>(null);
  const offsetRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const { date, view, selectedTeamMember, locationId } = useSelector(
    (state: {
      calendar: {
        date: Date;
        view: views;
        selectedTeamMember: number | null;
        locationId: number | null;
      };
    }) => {
      return {
        date: new Date(state.calendar.date),
        view: state.calendar.view,
        selectedTeamMember: state.calendar.selectedTeamMember,
        locationId: state.calendar.locationId,
      };
    }
  );

  let startDate = "";
  let endDate = "";
  switch (view) {
    case "week":
      const weekDays = getWeekDays(date);
      startDate = weekDays[0].dayDate;
      endDate = weekDays[6].dayDate;
      break;
    // startDate = weekStart(date);
    // endDate = weekEnd(date);
    // break;
    case "day":
      startDate = formatDateToYYYYMMDD(date);
      endDate = startDate;
      break;
    // case "month":
    //   startDate = formatDateToYYYYMMDD(date);
    //   const dateCopy = new Date(date);
    //   dateCopy.setMonth(dateCopy.getMonth() + 1);
    //   endDate = formatDateToYYYYMMDD(dateCopy);

    //   break;
  }
  const params: any = {
    "date_range[from]": startDate,
    "date_range[to]": endDate,
    status: statusFilter,
    client_search: searchFilter,
  };
  if (selectedTeamMember !== null) {
    params["team_member_id"] = selectedTeamMember;
  }
  const { data } = useQuery(
    [
      "appointments",
      date,
      view,
      selectedTeamMember,
      locationId,
      searchFilter,
      statusFilter,
    ],
    () => getAppointments(locationId, params),
    {
      enabled: !!locationId,
    }
  );
  useEffect(() => {
    const minute = new Date().getHours() * 60;
    if (!containerRef.current) return;
    if (!navRef.current) return;
    if (!offsetRef.current) return;
    containerRef.current.scrollTop =
      ((containerRef.current.scrollHeight -
        navRef.current.offsetHeight -
        offsetRef.current.offsetHeight) *
        minute) /
      1440;
  }, []);
  return (
    <div
      ref={containerRef}
      className="isolate flex flex-auto flex-col overflow-auto bg-white"
    >
      <div
        style={{ width: "165%" }}
        className=" flex max-w-full flex-none flex-col sm:max-w-none md:max-w-full"
      >
        <CalendarNav
          containerNav={navRef}
          appointments={data?.data?.data || []}
        />
        <div className="flex flex-auto">
          <div className="sticky left-0 z-10 w-16 flex-none bg-white ring-1 ring-gray-100 " />
          <div
            className="grid flex-auto grid-cols-1 grid-rows-1 "
            ref={offsetRef}
          >
            {/* Horizontal lines */}
            <SideBarHours containerOffset={containerRef} />
            {/* Vertical lines */}
            <VerticalLines clickOnDay={clickOnDay} />
            <Appointments
              appointments={data?.data?.data || []}
              dateAndTime={dateAndTime}
              setDateAndTime={setDateAndTime}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarBody;
